import { useEventCallback } from '@mui/material/utils';
import { Location } from 'react-router';

import { unawaited } from '../../utils/promise';
import { useAccessToken } from '../providers/AccessTokenContext';

export function useSignIn() {
  const { signIn } = useAccessToken();

  const fn = useEventCallback(
    (location: Location | undefined, accountId?: string | null, orgId?: string | null) => {
      if (typeof signIn === 'function') {
        unawaited(signIn(location, accountId, orgId));
      }
    },
  );

  return {
    signInWithPath: typeof signIn === 'function' ? fn : undefined,
  };
}
